import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CounterpartyContactsColumn {
    NAME = "name",
    EMAIL = "email",
    PHONE = "phone",
    PRIMARY = "primary",
    ACTIONS = "actions",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyContactsColumn.NAME),
});
const EmailColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyContactsColumn.EMAIL),
});
const PhoneColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyContactsColumn.PHONE),
});
const PrimaryColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyContactsColumn.PRIMARY),
});
const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyContactsColumn.ACTIONS),
});

export const CounterpartyContactsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.COUNTERPARTY_CONTACTS),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            EmailColumnSchema,
            PhoneColumnSchema,
            PrimaryColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type CounterpartyContactsView = z.infer<
    typeof CounterpartyContactsViewSchema
>;
